import React from 'react';
import './index.scss';

const CustomCheckbox = ({
  option,
  isSelected,
  onSelect,
}) => {
  return (
    <div
      className={`donation-item ${isSelected ? 'active' : ''}`}
      onClick={() => onSelect(option)}
    >
      <div className="donation-content">
        <input
          type="radio"
          id={`option-${option}`}
          name="donation-option"
          checked={isSelected}
          onChange={() => onSelect(option)}
        />
        <label
          htmlFor={`option-${option}`}
          onClick={(e) => e.stopPropagation()}
        >
          {option}
        </label>
      </div>
    </div>
  );
};

export default CustomCheckbox;
